var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cart__remove-button",attrs:{"name":"remove"},on:{"click":_vm.submit}},[_c('img',{staticClass:"remove-button__icon",attrs:{"src":require("img/x_gray.svg"),"alt":"remove"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }